<template>
  <v-app-bar>
    <v-img
      v-if="hasLogo"
      class="mx-6"
      :src="logoSrc"
      max-height="40"
      max-width="80"
    ></v-img>
    <v-app-bar-title>{{ title }}</v-app-bar-title>

    <template v-slot:append>
      <p class="mr-10">{{ email }}</p>
    </template>
  </v-app-bar>
</template>

<script>
const idToken = localStorage.getItem("idToken");

let email = "Not signed in.";
if (idToken != null) {
  let payload = JSON.parse(atob(idToken.split(".")[1]));
  email = "Signed in as: " + payload.email;
}

// Branding is config-driven. The logo lives in src/assets/logo.png (copied from
// the project's assets/branding/ on deploy). If it's missing, we just show text.
let logoSrc = null;
let hasLogo = false;
try {
  logoSrc = require("@/assets/logo.png");
  hasLogo = true;
} catch (e) {
  hasLogo = false;
}

export default {
  data() {
    return {
      email,
      logoSrc,
      hasLogo,
      title: process.env.VUE_APP_TITLE || "Management Portal",
    };
  },
};
</script>
